// gatsby-browser.js
import "./static/fonts/stylesheet.css"
import "./src/styles/global.css"
import "./src/styles/project.css"

import React from "react"

/**
 * Just render the page as-is
 */
export const wrapPageElement = ({ element }) => {
  return <>{element}</>
}
